var _defs, _rect, _g, _path, _path2, _path3, _rect2, _path4, _path5, _polygon, _polygon2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81.79 51.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.j{fill:none;}.b{fill:#414042;}.c{clip-path:url(#a);}.d{fill:#fff;}.e{fill:#ed7e22;}.f{fill:#e12a26;}.g{fill:url(#b);}.h{fill:#0a191e;}.i{fill:#1d1d1b;}.j{stroke:#231f20;stroke-miterlimit:10;stroke-width:0.25px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.13,
    y: 0.13,
    width: 80.67,
    height: 50,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 35.86,
    cy: -467.17,
    r: 5.61,
    gradientTransform: "translate(6.42 486.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff3e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#feeee0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fcdfc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f8c8a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f3a769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec7e23"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Discover_shadow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1.13,
    y: 1.13,
    width: 80.67,
    height: 50,
    rx: 11,
    ry: 11
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.13,
    width: 80.64,
    height: 50.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M80.82,24.75s-25,17.62-70.7,25.51h70.7Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M71,43.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M42.28,13.37a5.58,5.58,0,0,0-5.68,5.47,5.67,5.67,0,1,0,5.68-5.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M10,13.57H7V24.22h3A5.55,5.55,0,0,0,13.82,23a5.36,5.36,0,0,0,1.93-4.09C15.75,15.75,13.4,13.57,10,13.57Zm2.43,8a3.93,3.93,0,0,1-2.85.85H9.06v-7h.56a3.85,3.85,0,0,1,2.85.86,3.58,3.58,0,0,1,1.15,2.65A3.64,3.64,0,0,1,12.46,21.57Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 16.71,
    y: 13.57,
    width: 2.08,
    height: 10.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M23.87,17.65c-1.25-.46-1.61-.77-1.61-1.34s.65-1.18,1.55-1.18a2.16,2.16,0,0,1,1.68.86l1.08-1.42a4.65,4.65,0,0,0-3.13-1.18,3.13,3.13,0,0,0-3.32,3c0,1.47.67,2.22,2.62,2.92a8,8,0,0,1,1.44.61,1.27,1.27,0,0,1,.62,1.1,1.52,1.52,0,0,1-1.61,1.5,2.46,2.46,0,0,1-2.27-1.42l-1.34,1.3a4.14,4.14,0,0,0,3.69,2A3.44,3.44,0,0,0,26.93,21C26.93,19.28,26.23,18.52,23.87,17.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M27.59,18.9a5.52,5.52,0,0,0,5.62,5.56,5.73,5.73,0,0,0,2.6-.62V21.39a3.32,3.32,0,0,1-2.51,1.17,3.48,3.48,0,0,1-3.58-3.67,3.54,3.54,0,0,1,3.48-3.66,3.48,3.48,0,0,1,2.6,1.2V14a5.31,5.31,0,0,0-2.56-.65A5.6,5.6,0,0,0,27.59,18.9Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "52.65 20.72 49.8 13.57 47.54 13.57 52.06 24.49 53.17 24.49 57.77 13.57 55.52 13.57 52.65 20.72"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "58.72 24.22 64.61 24.22 64.61 22.41 60.8 22.41 60.8 19.54 64.47 19.54 64.47 17.73 60.8 17.73 60.8 15.37 64.61 15.37 64.61 13.57 58.72 13.57 58.72 24.22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M72.83,16.71c0-2-1.37-3.14-3.77-3.14H66V24.22h2.08V19.94h.27l2.87,4.28h2.56l-3.36-4.49A2.83,2.83,0,0,0,72.83,16.71Zm-4.17,1.76h-.6V15.24h.64c1.3,0,2,.54,2,1.58S70,18.47,68.67,18.47Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M74.3,14.36c0-.19-.12-.29-.35-.29h-.3V15h.22v-.36l.26.36h.28l-.31-.39A.26.26,0,0,0,74.3,14.36Zm-.39.13h0v-.24h0c.11,0,.17,0,.17.12S74,14.49,73.91,14.49Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M74,13.72a.82.82,0,1,0,.81.82A.82.82,0,0,0,74,13.72Zm0,1.49a.67.67,0,1,1,.65-.67A.66.66,0,0,1,74,15.21Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M25.6,27l2.78,2.91V27.17h.4v3.72L26,28v2.75h-.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M25.56,27v3.75H26V28.08L28.81,31V27.13h-.47v2.7l-2.78-2.91Zm.07.09L28.42,30V27.21h.32v3.6L26,27.89v2.8h-.32Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M30.7,27.17h1.85v.37H31.1V28.6h1.41V29H31.1v1.4h1.45v.37H30.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M32.55,27.13H30.66v3.64h1.92v-.44H31.14V29h1.41v-.44H31.14v-1h1.45v-.45Zm0,.07v.3H31.06v1.13h1.41v.29H31.06V30.4h1.45v.29H30.74V27.21Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M35.35,30.73H35v-3.2H34.1v-.37h2.13v.37h-.87Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.22,27.13H34.06v.45h.86v3.19h.47V27.58h.87v-.45Zm0,.07v.3h-.87v3.2H35V27.5h-.86v-.3Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.88,29.84,40,27l1.15,2.86.94-2.67h.43l-1.37,3.75L40,28l-1.15,2.87-1.36-3.75h.43Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M40,27l-1.12,2.76L38,27.13h-.51L38.88,31,40,28.15,41.19,31l1.42-3.89h-.51l-.91,2.6L40,26.89Zm-1.09,2.88L40,27.09l1.15,2.86,1-2.74h.35l-1.32,3.61L40,27.95l-1.15,2.87-1.31-3.61h.35l1,2.74Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M47.68,29a1.86,1.86,0,1,1-1.86-1.85A1.85,1.85,0,0,1,47.68,29Zm-3.32,0a1.46,1.46,0,1,0,1.46-1.48A1.47,1.47,0,0,0,44.37,29Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M43.93,29a1.89,1.89,0,1,0,1.89-1.88A1.89,1.89,0,0,0,43.93,29ZM44,29a1.82,1.82,0,1,1,1.82,1.8A1.82,1.82,0,0,1,44,29Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M44.33,29a1.5,1.5,0,1,0,1.5-1.51A1.51,1.51,0,0,0,44.33,29Zm.08,0a1.42,1.42,0,1,1,1.42,1.44A1.43,1.43,0,0,1,44.4,29Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M49.8,30.73h-.4V27.17h.51c.68,0,1.3.18,1.3,1a.93.93,0,0,1-.89,1l1.13,1.6H51L49.9,29.17h-.1Zm0-1.91h.12c.45,0,.9-.08.9-.64s-.43-.64-.91-.64H49.8Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M49.41,27.13h0v3.64h.47V29.21h.06s1,1.55,1,1.55l.52,0h.07l-1.14-1.61a1,1,0,0,0,.87-1c0-.69-.44-1-1.34-1Zm.51.07c.86,0,1.27.3,1.27.95a.9.9,0,0,1-.86.95h-.07l1.13,1.59H51s-1-1.55-1-1.55l-.13,0h0V30.7h-.32V27.21Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M49.8,27.5h0v1.35h.16c.44,0,.94-.08.94-.67s-.49-.68-.94-.68Zm.12.08c.46,0,.87,0,.87.6s-.44.6-.86.6h-.09v-1.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.06,27.17h.53l-1.67,1.66,1.73,1.9H55.1L53.64,29.1l-.1.1v1.54h-.4V27.17h.4V28.7Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.6,27.13H55l-1.47,1.47V27.13h-.47v3.64h.47V29.2l.06,0,1.44,1.61h.66L54,28.83l1.71-1.7Zm-.09.07-1.63,1.62,1.7,1.87H55.1s-1.43-1.62-1.43-1.62l0,0-.13.13s0,1.45,0,1.53h-.32V27.21h.32v1.58l1.57-1.58Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 0.13,
    y: 0.13,
    width: 80.67,
    height: 50,
    rx: 11,
    ry: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.373d0a2e3f80a15a6eed71ffaddf6361.svg";
export { ForwardRef as ReactComponent };